var _defs, _path, _defs2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "svg",
    viewBox: "0 0 1440 700",
    xmlns: "http://www.w3.org/2000/svg",
    className: "transition duration-300 ease-in-out delay-150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#002bdc88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#0693e388"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,700 C 0,700 0,233 0,233 C 76.01913875598089,283.8995215311005 152.03827751196178,334.79904306220095 245,319 C 337.9617224880382,303.20095693779905 447.86602870813397,220.70334928229664 564,207 C 680.133971291866,193.29665071770336 802.4976076555024,248.38755980861248 895,269 C 987.5023923444976,289.6124401913875 1050.1435406698563,275.7464114832536 1136,264 C 1221.8564593301437,252.2535885167464 1330.9282296650717,242.6267942583732 1440,233 C 1440,233 1440,700 1440,700 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "url(#gradient)",
    className: "transition-all duration-300 ease-in-out delay-150 path-0",
    transform: "rotate(-180 720 350)"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#002bdcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#0693e3ff"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,700 C 0,700 0,466 0,466 C 90.14354066985646,487.24401913875596 180.28708133971293,508.4880382775119 284,490 C 387.7129186602871,471.5119617224881 504.9952153110048,413.2918660287081 594,395 C 683.0047846889952,376.7081339712919 743.7320574162677,398.3444976076555 829,435 C 914.2679425837323,471.6555023923445 1024.0765550239237,523.3301435406698 1130,531 C 1235.9234449760763,538.6698564593302 1337.961722488038,502.3349282296651 1440,466 C 1440,466 1440,700 1440,700 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "url(#gradient)",
    className: "transition-all duration-300 ease-in-out delay-150 path-1",
    transform: "rotate(-180 720 350)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.1d3438b037dbb707c42a8fabebad932c.svg";
export { ForwardRef as ReactComponent };